// progress reducer
const RESET = 'RESET_GAME'
const SET_IN_GAME = 'SET_IN_GAME'
const SET_POST_GAME = 'SET_POST_GAME'

function progress(state='intro', action) {
	switch(action.type) {
		case SET_IN_GAME:
			return 'in_game'
		case SET_POST_GAME:
			return 'post_game'
		case RESET:
			return 'intro'
		default:
			return state
	}
}

function setInGameAction() {
	return {
		type: SET_IN_GAME
	}
}

function setPostGameAction() {
	return {
		type: SET_POST_GAME
	}
}

function reset() {
	return {
		type: RESET
	}
}

export { progress, setInGameAction, setPostGameAction, reset }



// WEBPACK FOOTER //
// ./src/reducers/progress.js